/**
 * App Module
 */
import Vue from 'vue'
import Nprogress from 'nprogress';
import router from '../../../router';
import api from '../../../api'
import { ONE_MONTH_IN_MILLISECONDS } from '../../../constants/db-config';
const state = {
    rooms: [],
    wallets: [],
    cashWallets: [],
    bvs: [],
    latestPaymentLog: undefined,
    blockEditDate: (new Date(Date.now() - ONE_MONTH_IN_MILLISECONDS)).toISOString(),
    loading: false,
}

// getters
const getters = {
    getListRooms: state => {
        return state.rooms;
    },
}

// actions
const actions = {
    getAppData(context){
        context.dispatch('getListRooms')
        context.dispatch('getListWallets')
        context.dispatch('getListBvs')
        context.dispatch('getLatestPaymentLog')
    },
    async getListRooms(context) {
        let data = await api.getListRoom()
        if (data.status === 200){
            context.commit('rooms', data.data)
        } else {
            console.log('Không thể get list rooms');
        }
        return true
    },
    async getListWallets(context) {
        let data = await api.getListWallets()
        if (data.status === 200){
            context.commit('wallets', data.data);
            context.commit('cashWallets', data.data.filter(
                (item) => item.name && item.name.toLowerCase().includes("tiền mặt") && item.name !== 'Tiền mặt'
            ))
        } else {
            console.log('Không thể get list wallets');
        }
        return true
    },
    async getListBvs(context) {
        let data = await api.getListBvs()
        if (data.status === 200){
            context.commit('bvs', data.data)
        } else {
            console.log('Không thể get list bvs');
        }
        return true
    },
    async getLatestPaymentLog(context) {
        try {
            const data = await api.getLatestPaymentLog();

            if (data.status === 200) {
                context.commit("latestPaymentLog", data.data);

                const { month } = data.data;
                const [year, monthNumber] = month.split("-")

                const blockEditDate = new Date(+year, +monthNumber - 1);
                
                context.commit("blockEditDate", blockEditDate.toISOString());
            }

        } catch (error) {
            console.error("Không thể get latest payment log", error);
        }

        return true
    },
}

// mutations
const mutations = {
    rooms(state, payload) {
        state.rooms = payload.slice(0)
    },
    wallets(state, payload){
        state.wallets = payload.slice(0)
    },
    cashWallets(state, payload){
        state.cashWallets = payload.slice(0)
    },
    bvs(state, payload){
        state.bvs = payload.slice(0)
    },
    latestPaymentLog(state, payload){
        state.latestPaymentLog = { ...payload };
    },
    blockEditDate(state, payload){
        state.blockEditDate = payload;
    },
    loading(state, payload) {
        state.loading = payload
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
